import * as swcHelpers from '@swc/helpers';
import React__default, { useRef, useState } from 'react';
import { BrComponent } from '@bloomreach/react-sdk';
import { generateConditionalClassNames, removeWhiteSpaceChars, scrollToNextTab } from '../utils/utils.js';
import { RowTabButton } from './RowTabButton.js';

var CmsRowTab = ({ component  })=>{
    const _ref = component.getParameters(), { showInDesktop , showInTablet , showInPhone , fullWidth  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "showInDesktop",
        "showInTablet",
        "showInPhone",
        "fullWidth"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const tabRefs = useRef(Array(component.getChildren().length).fill(null));
    const tabButtonsTitles = component.getChildren().map((row)=>row.getParameters().tabButtonTitle
    );
    const [selectedTab, setSelectedTab] = useState(0);
    const handleClick = (index)=>{
        setSelectedTab(index);
        scrollToNextTab(tabRefs, index);
    };
    const handleNextTab = (nextTab)=>{
        setSelectedTab(nextTab);
        tabRefs.current[nextTab].focus();
        scrollToNextTab(tabRefs, nextTab);
    };
    const handleKeyPress = (event)=>{
        const tabCount = Object.keys(tabButtonsTitles).length;
        if (event.key === 'ArrowLeft') {
            const nextTab = selectedTab - 1;
            if (nextTab >= 0) {
                handleNextTab(nextTab);
            }
        }
        if (event.key === 'ArrowRight') {
            const nextTab = selectedTab + 1;
            if (nextTab < tabCount) {
                handleNextTab(nextTab);
            }
        }
    };
    const rowClassName = generateConditionalClassNames('br-row-tabs', {
        fullWidth,
        showInDesktop,
        showInTablet,
        showInPhone
    });
    return /*#__PURE__*/ React__default.createElement("section", {
        className: rowClassName,
        "data-t": "br-row-tabs",
        style: swcHelpers.objectSpread({}, filteredStyles)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "br-row-tabs_buttons",
        "data-t": "br-row-tabs_buttons"
    }, /*#__PURE__*/ React__default.createElement("ul", {
        role: "tablist",
        "aria-label": "List of tabs",
        onKeyDown: handleKeyPress
    }, Object.keys(tabButtonsTitles).map((key, index)=>/*#__PURE__*/ React__default.createElement(RowTabButton, {
            id: removeWhiteSpaceChars(`rowTabButton-${tabButtonsTitles[key]}`),
            tabRowId: removeWhiteSpaceChars(`rowTabPanel-${tabButtonsTitles[key]}`),
            index: parseInt(key),
            handleChange: handleClick,
            selectedTab: selectedTab,
            tabRef: (element)=>{
                tabRefs.current[index] = element;
            },
            title: tabButtonsTitles[key],
            key: key
        })
    ))), /*#__PURE__*/ React__default.createElement("div", {
        className: "br-row-tabs_slides"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "br-row-tabs_slides-wrapper"
    }, /*#__PURE__*/ React__default.createElement(BrComponent, null))));
};
var CmsRowTab$1 = CmsRowTab;

export { CmsRowTab, CmsRowTab$1 as default };
//# sourceMappingURL=RowTab.js.map
